export const BASE_URL= process.env.REACT_APP_API_HOST || 'https://api.metaflix.az'
export const CONTENT_KEY= process.env.REACT_APP_CONTENT_KEY || 'EdZ8UD9UnbFkZdC6bbMuujldY70lbi0a33tnjauz'
export const IMAGE_BUCKET_URL="https://media.metaflix.az/"